import React from "react";
import "./LoadingOverlay.css"; // CSS dosyasını dahil ettik
import loadingImg from '../../assets/images/login-logo.png'
import { useLanguage } from "../../LanguageProvider";

const LoadingOverlay = () => {
    const { getTranslation } = useLanguage();

    return (
        <div className="loading-overlay">
            <img src={loadingImg} height={50} alt="Loading" />
            <div className="loading-content">
                <div style={{width:'100%',alignItems:'center',justifyContent:'center',flexDirection:'column',display:'flex',gap:'20px'}}>

                    <span className="loading-content-title">
                        {getTranslation("loading")}
                    </span>
                    <span className="loading-content-message">
                        {getTranslation("operationInProgress")}
                    </span>

                </div>
                <div className="progress-bar">
                    <div className="progress"></div>
                </div>
            </div>
        </div>
    );
};

export default LoadingOverlay;
